import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      roleId: '',
      userId: '',
      userFullName: '',
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchModal: false,
      userAllRoles: [],
      //row 1
      callsCount: '',
      allWorkingTime: '',
      callDurationAverage: '',
      consultantCount: '',
      //row 2
      loginLogoutTableHeader: [
        { text: 'تاریخ ورود', value: 'loginDate', align: 'start' },
        { text: 'تاریخ خروج', value: 'logoutDate', align: 'start' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
      ],
      loginLogoutTableItems: [],
      //pie call
      pieActionChartOption: {
        colors: [
          '#FF7600',
          '#007D83',
          '#002E91',
          '#D69415',
          '#C66512',
          '#0CC881',
          '#4986FF',
          '#FFB528',
          '#FF6925',
          '#02F4FF',
          '#1A63FF',
          '#FFA900',
        ],
        chart: {
          renderTo: 'dashboardQCPieCallChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      diagnosisColumnChartOption: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: [],
          useHTML: true,
          reversed: false,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          stackLabels: {
            style: {
              backgroundColor: 'rgba(252, 255, 197, 0.7)',
              color: 'black',
              borderWidth: 1,
              wordWrap: 'break-word',
            },
            enabled: true,
            useHTML: true,
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          backgroundColor: 'white',
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{series.name}</span>: <span  style="color:white">{point.y}</span></div>',
        },
        plotOptions: {
          useHTML: true,
          series: {
            borderWidth: 0,
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{series.name}: {point.y}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '9px',
                wordWrap: 'break-word',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [],
      },
      //row 4
      drugsColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#6CBB5F',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'دارو',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    readyDashboard: function (data) {
      this.callsCount = data.callsCount ? data.callsCount.valueLong : '-';
      let duration = Math.round(data.workingHours.valueDouble);
      duration = duration * 1000;
      this.allWorkingTime = this.msToTime(duration);
      let duration1 = Math.round(data.callDurationAverage.valueDouble);
      duration1 = duration1 * 1000;
      this.callDurationAverage = this.msToTime(duration1);
      this.consultantCount = data.consultantCount ? data.consultantCount.valueLong : '-';
      //row2
      //pie Call
      let pieChartData2 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
      pieChartTempArray2 = JSON.parse(JSON.stringify(data.callTags));
      for (let i = 0; i < pieChartTempArray2.length; i++) {
        pieChartData2.push({
          name: pieChartTempArray2[i].title,
          y: pieChartTempArray2[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
      this.pieActionChartOption.series[0].data = [];
      this.pieActionChartOption.series[0].data = pieChartData2;
      //row 3
      if (data.diagnosesWithResult.length > 0) {
        let columnData = [];
        for (let i = 0; i < data.diagnosesWithResult.length; i++) {
          this.diagnosisColumnChartOption.xAxis.categories.push(data.diagnosesWithResult[i].title);
        }
        for (let j = 0; j < data.diagnosesWithResult[0].subItems.length; j++) {
          columnData.push({
            name: data.diagnosesWithResult[0].subItems[j].title,
            data: [],
          });
        }
        for (let i = 0; i < columnData.length; i++) {
          for (let j = 0; j < data.diagnosesWithResult.length; j++) {
            for (let z = 0; z < data.diagnosesWithResult[j].subItems.length; z++) {
              if (columnData[i].name == data.diagnosesWithResult[j].subItems[z].title) {
                if (data.diagnosesWithResult[j].subItems[z].valueLong > 0) {
                  columnData[i].data.push(data.diagnosesWithResult[j].subItems[z].valueLong);
                } else {
                  columnData[i].data.push(null);
                }
              }
            }
          }
        }
        this.diagnosisColumnChartOption.series = columnData;
      }
      //row 4
      let coluumnDrugChartData = JSON.parse(JSON.stringify([]));
      let coluumnDrugTempArray = JSON.parse(JSON.stringify([]));
      coluumnDrugTempArray = JSON.parse(JSON.stringify(data.drugs));
      for (let i = 0; i < coluumnDrugTempArray.length; i++) {
        coluumnDrugChartData.push({
          name: coluumnDrugTempArray[i].title,
          y: coluumnDrugTempArray[i].valueLong,
          text: coluumnDrugTempArray[i].valueLong.toString(),
        });
      }
      coluumnDrugChartData = JSON.parse(JSON.stringify(coluumnDrugChartData));
      this.drugsColumnChartOptions.series[0].data = [];
      this.drugsColumnChartOptions.series[0].data = coluumnDrugChartData;
    },
    readyLoginLogoutData: function (data) {
      this.loginLogoutTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.loginLogoutTableItems.push({
          loginDate: loginDate,
          logoutDate: logoutDate,
          duration: this.msToTime(duration),
        });
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      this.$router.push({ name: 'qcUsersForQCReport' });
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.getUserRoleList();
      this.searchModal = true;
    },
    search: function () {
      this.searchModal = false;
      this.getQCUserDoctorDashboardFunction(this.searchFromDate, this.searchToDate, this.userId);
      this.getQCUsersLoginLogoutReportFunction(this.searchFromDate, this.searchToDate, this.userId);
    },
    cancelSearch: function () {
      this.searchModal = false;
    },
    showAllLoginLogout: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'user115AllLoginLogout', params: { id: id } });
    },
  },
};
